import { ReactNode, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import PlainButton from 'app/common/ui-next/plain-button'
import useCallbackRef from 'app/common/hooks/useCallbackRef'

import { FundColumns, Column, Header, Content, Comment } from '../FundColumns'
import RefillConfirm from './RefillConfirm'


type Props = {
  ID?: string
  header?: ReactNode | string
  content?: ReactNode | string
  comment?: ReactNode | string
  onRefillClick: (ID?: string) => void
  withWarning?: boolean
  warningText?: string
  warningBtText?: string
  outline?: boolean
  loading?: boolean
  className?: string
  firstColumnClassName?: string
}

const RefillItem = ({
  ID,
  header,
  content,
  comment,
  onRefillClick,
  withWarning,
  warningText,
  warningBtText,
  outline,
  loading,
  className,
  firstColumnClassName,
}: Props) => {
  const { t } = useTranslation('finances')

  const onRefillClickRef = useCallbackRef(onRefillClick)

  const handleClick = useCallback(() => {
    onRefillClickRef.current?.(ID)
  }, [onRefillClickRef, ID])

  return (
    <FundColumns className={className}>
      <Column className={firstColumnClassName}>
        {header
          && <Header>{header}</Header>}
        {content
          && <Content>{content}</Content>}
        {comment
          && <Comment>{comment}</Comment>}
      </Column>
      <Column>
        {withWarning

          ? <RefillConfirm
            confirmButtonTitle={warningBtText || 'Ok'}
            cancelButtonTitle={t('transfer_cancel_bt', 'Отмена') ?? ''}
            messageText={warningText || 'Вы уверены?'}
            onConfirm={handleClick}
          >
            {toggle => (
              <PlainButton
                outline={outline}
                disabled={loading}
                onClick={toggle}
              >
                {loading ? t('refill_bt_loading') : t('refill_bt')}
              </PlainButton>
            )}
          </RefillConfirm>

          : <PlainButton
            outline={outline}
            onClick={handleClick}
            disabled={loading}
          >
            {loading ? t('refill_bt_loading') : t('refill_bt')}
          </PlainButton>}
      </Column>
    </FundColumns>
  )
}

export default RefillItem
